import { Component, ElementRef, input, output, viewChild } from "@angular/core";
import { BadgeModule } from "primeng/badge";

/**
 * Icon-sized capture control for compact rows.
 *
 * `app-photo-capture` owns a whole form field (thumbnail grid, pager, capture buttons); this is the
 * single-tap counterpart used where only the shutter is wanted, e.g. an answered checklist row or a
 * logged issue card.
 */
@Component({
  selector: "app-photo-capture-button",
  standalone: true,
  imports: [BadgeModule],
  templateUrl: "./photo-capture-button.component.html",
  styleUrl: "./photo-capture-button.component.scss"
})
export class PhotoCaptureButtonComponent {
  ariaLabel = input<string>("Add photo");
  disabled = input<boolean>(false);
  /** Rendered as a badge on the icon; hidden when zero. */
  count = input<number>(0);
  /** `camera` opens the device camera directly, `library` the multi-select photo picker. */
  source = input<"camera" | "library">("camera");
  inputId = input<string>("photo-capture-button");
  testId = input<string>("app-photo-capture-button");

  readonly filesSelected = output<File[]>();

  private readonly fileInput = viewChild<ElementRef<HTMLInputElement>>("fileInput");

  protected trigger(): void {
    this.fileInput()?.nativeElement.click();
  }

  protected handleFiles(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files ? Array.from(target.files) : [];
    // Cleared so re-picking the same file still raises a change event.
    target.value = "";

    if (files.length === 0) {
      return;
    }

    this.filesSelected.emit(files);
  }
}
